import { HeaderTabType } from '../enums';
import { Tab } from '../components/layout/HeaderTabs';

export const TABS: Tab[] = [
    { title: 'Easy Selection HV motors', to: '/', type: HeaderTabType.Selector }
];
